// Extensiones de adjuntos permitidas para subir en documentos relacionados 
const EXTENSIONES_ADJ_EXTERNOS = [
  'HTML',
  'PDF',
]

const EXTENSIONES_ADJ_EXTERNOS_FACEB2B = [
  'XML',
  'XSIG',
  'PDF',
  'ZIP',
]

export {
  EXTENSIONES_ADJ_EXTERNOS,
  EXTENSIONES_ADJ_EXTERNOS_FACEB2B
}
